import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useDispatch, useSelector } from "react-redux";
import { Refresh } from "@mui/icons-material";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import { checkingFilter } from "../../../../utils/checkFilter";
import {
  deleteJobPosition,
  getJobPosition,
  jobPositionActions,
  sortJobPosition,
  updateJobPosition,
} from "../../../../redux/reducer/jobPosition/jobPositionReducer";
import AdminJobPositionTambah from "./AdminJobPositionTambah";
import AdminJobPositionEdit from "./AdminJobPositionEdit";
import { getRefreshTime } from "../../../../utils/getRefreshTime";
import CustomTable from "../../../table/CustomTable";
import AdminJobPositionDetail from "./AdminJobPositionDetail";

const useStyles = makeStyles(() => ({
  headerClassSearch: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    padding: "0px 5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  tableHead: {
    backgroundColor: "#f5f2e6",
  },
  actionButtonDelete: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    borderRadius: "5px",
    cursor: "pointer",
    "&:hover": {
      background: "#ba2941",
    },
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    borderRadius: "5px",
    marginRight: "10px",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminJobPosition() {
  // Styling
  const styles = useStyles();

  //Redux
  const data = useSelector((state) => state.jobPosition.data);
  const getTime = useSelector((state) => state.jobPosition.updatedTime);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();

  // Local State
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openForm, setOpenForm] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [editId, setEditId] = useState(null);
  const [viewId, setViewId] = useState(null);
  const [formInput, setFormInput] = useState({
    to: "",
    from: "",
    positionName: "",
    limit: 0,
  });
  const [sortingField, setSortingField] = useState([]);
  const [fetch, setFetch] = useState(true);
  const [timeUpdated, setTimeUpdated] = useState({
    hour: 0,
    minute: 0,
  });
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (fetch) {
      handleAddSort();
      setFetch(false);
    }
    if (getTime > 0) {
      setTimeUpdated(getRefreshTime(getTime));
    }
  }, [fetch, getTime]);

  // Handling Sorting
  const handleSort = (index) => (e) => {
    const newItems = [...sortingField];
    newItems[index][e.target.name] = e.target.value;
    setSortingField(newItems);
  };

  const handleAddSort = () => {
    setSortingField((prevItems) => [
      ...prevItems,
      {
        sorting: "asc",
        field: "createdAt",
      },
    ]);
  };

  const handleDeleteSort = (value) => {
    let deletedData = [];
    for (let i = 0; i < sortingField.length; i++) {
      if (i !== value) {
        deletedData.push(sortingField[i]);
      }
    }
    setSortingField(deletedData);
  };

  const handleChangeInput = (e) => {
    setFormInput({ ...formInput, [e.target.name]: e.target.value });
  };

  const handleChangePage = (event, newPage) => {
    if (event) {
      setPage(newPage);
      const getData = {
        params: {
          page: newPage + 1,
          limit: 10,
        },
        token: token,
      };
      dispatch(getJobPosition(getData));
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const column = ["Nama jabatan", "Aksi"];

  const listData = ["positionName"];

  const deleteClassItem = (id) => {
    Swal.fire({
      title: `Apakah anda yakin ingin menghapus permanen jabatan ini?`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        const deleteData = {
          data: id,
          token: token,
        };
        dispatch(deleteJobPosition(deleteData)).then((res) => {
          if (res.payload.status === 200) {
            dispatch(jobPositionActions.deleteJobPosition(id));
            toast.success(res.payload.message);
          } else {
            toast.error(res.payload.message);
          }
        });
      } else {
        return;
      }
    });
  };

  const deleteTemporary = (id) => {
    Swal.fire({
      title: `Apakah anda yakin ingin menghapus jabatan ini?`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        const deleteData = {
          value: {
            isActive: false,
          },
          id: id,
          token: token,
        };
        dispatch(updateJobPosition(deleteData)).then((res) => {
          if (res.payload.status === 200) {
            dispatch(jobPositionActions.deleteJobPosition(id));
            toast.success(res.payload.message);
          } else {
            toast.error(res.payload.message);
          }
        });
      } else {
        return;
      }
    });
  };

  const activeClassItem = (id) => {
    Swal.fire({
      title: `Apakah anda yakin ingin mengaktifkan jabatan ini?`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aktifkan",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        const activatedData = {
          value: {
            isActive: true,
          },
          id: id,
          token: token,
        };
        dispatch(updateJobPosition(activatedData)).then((res) => {
          if (res.payload.status === 200) {
            dispatch(
              getJobPosition({
                params: {
                  params: {},
                },
                token: token,
              })
            );
            toast.success(res.payload.message);
          } else {
            toast.error(res.payload.message);
          }
        });
      } else {
        return;
      }
    });
  };

  const handleEditData = (id) => {
    setEditId(id);
    setOpenEdit(true);
  };

  const handleViewData = (id) => {
    setViewId(id);
    setOpenView(true);
  };

  const handleSubmit = () => {
    dispatch(
      sortJobPosition(
        checkingFilter(
          1,
          formInput,
          sortingField,
          "positionName",
          token,
          isActive
        )
      )
    ).then((res) => {
      toast.success(res.payload.message);
    });
  };

  const handleReset = () => {
    setSortingField([]);
    setIsActive(true);
    handleAddSort();
    setFormInput({
      to: "",
      from: "",
      limit: 0,
      positionName: "",
    });
  };

  const handleUpdate = () => {
    const getData = {
      params: {
        params: {},
      },
      token: token,
    };
    dispatch(getJobPosition(getData));
  };

  return (
    <>
      <ToastContainer />
      <Card className={styles.headerClassSearch}>
        <Grid padding={0.5} container spacing={0.5} flexDirection={"column"}>
          <Grid
            item
            container
            xs={12}
            sm={12}
            direction="row"
            alignItems="center"
            justifyContent={"space-between"}
          >
            <div
              style={{ display: "flex", alignItems: "center", width: "10%" }}
            >
              <Typography variant="h6" color="primary">
                PENCARIAN
              </Typography>
            </div>
            <div style={{ display: "flex", width: "50%" }}>
              <FormControl
                variant="standard"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "80%",
                  margin: "10px",
                }}
              >
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Dari"
                  name="from"
                  size="small"
                  type="date"
                  onChange={handleChangeInput}
                  value={formInput.from}
                  variant="outlined"
                  style={{ width: "49%" }}
                />
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Ke"
                  name="to"
                  size="small"
                  type="date"
                  onChange={handleChangeInput}
                  value={formInput.to}
                  variant="outlined"
                  style={{ width: "49%" }}
                />
              </FormControl>
              <FormControl style={{ margin: "10px", width: "20%" }}>
                <TextField
                  onChange={handleChangeInput}
                  InputLabelProps={{ shrink: true }}
                  type="number"
                  size="small"
                  label="Limit"
                  name="limit"
                  value={formInput.limit}
                  fullWidth
                  variant="outlined"
                  style={{ width: "100%", maxWidth: "450px" }}
                />
              </FormControl>
            </div>
          </Grid>
          <Divider style={{ width: "100%", border: "1px solid black" }} />
          <Grid
            item
            container
            xs={12}
            sm={12}
            direction="column"
            justifyContent="space-evenly"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
              <div style={{ width: "15%" }}>
                <Typography>Kata Kunci</Typography>
              </div>
              <FormControl
                variant="standard"
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  width: "85%",
                  minWidth: "85%",
                  margin: "5px",
                }}
              >
                <TextField
                  select
                  size="small"
                  name="field"
                  value="positionName"
                  disabled
                  variant="outlined"
                  style={{ margin: "0px 10px", width: "20%" }}
                >
                  <MenuItem value="positionName">Nama</MenuItem>
                </TextField>
                <TextField
                  type="text"
                  size="small"
                  name="positionName"
                  value={formInput.positionName}
                  onChange={handleChangeInput}
                  placeholder="Masukkan kata kunci"
                  variant="outlined"
                  style={{ width: "44%" }}
                />
              </FormControl>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
              <div style={{ width: "15%" }}>
                <Typography>Urutkan</Typography>
              </div>
              <div style={{ width: "85%" }}>
                {sortingField.map((item, index) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                      key={index}
                    >
                      <FormControl
                        variant="standard"
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          flexDirection: "row",
                          width: "67.5%",
                          minWidth: "67.5%",
                          margin: "5px",
                        }}
                      >
                        <TextField
                          select
                          size="small"
                          name="field"
                          id={index}
                          onChange={handleSort(index)}
                          defaultValue="positionName"
                          value={item.field}
                          variant="outlined"
                          style={{ marginRight: "10px", width: "30%" }}
                        >
                          <MenuItem value="positionName">Nama</MenuItem>
                          <MenuItem value="createdAt">Tanggal</MenuItem>
                        </TextField>
                        <TextField
                          id={index}
                          select
                          size="small"
                          name="sorting"
                          onChange={handleSort(index)}
                          defaultValue="asc"
                          value={item.sorting}
                          variant="outlined"
                          style={{ width: "65%" }}
                        >
                          <MenuItem value="asc">Teratas</MenuItem>
                          <MenuItem value="desc">Terbawah</MenuItem>
                        </TextField>
                      </FormControl>

                      <AddIcon
                        className={styles.actionButtonEdit}
                        onClick={() => handleAddSort()}
                      />
                      {sortingField.length > 1 && index !== 0 ? (
                        <RemoveIcon
                          className={styles.actionButtonDelete}
                          onClick={() => handleDeleteSort(index)}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
              <div style={{ width: "15%" }}>
                <Typography>Status Data</Typography>
              </div>
              <div style={{ width: "85%" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <FormControl
                    variant="standard"
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "row",
                      width: "67.5%",
                      minWidth: "67.5%",
                      margin: "5px",
                    }}
                  >
                    <TextField
                      select
                      size="small"
                      name="field"
                      onChange={(e) => setIsActive(e.target.value)}
                      defaultValue="true"
                      value={isActive}
                      variant="outlined"
                      style={{ marginRight: "10px", width: "30%" }}
                    >
                      <MenuItem value="true">Aktif</MenuItem>
                      <MenuItem value="false">Tidak Aktif</MenuItem>
                    </TextField>
                  </FormControl>
                </div>
              </div>
            </div>
          </Grid>
          <Grid
            container
            item
            justifyContent="flex-end"
            xs={12}
            sm={12}
            marginBottom={1}
          >
            <Button
              variant="contained"
              size="small"
              style={{ margin: "0px 5px" }}
              onClick={() => handleSubmit()}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              size="small"
              color="error"
              style={{ margin: "0px 10px" }}
              onClick={() => handleReset()}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </Card>

      <AdminJobPositionTambah
        open={openForm}
        handleClose={() => setOpenForm(false)}
      />
      {editId ? (
        <AdminJobPositionEdit
          open={openEdit}
          handleClose={() => setOpenEdit(false)}
          clear={() => setEditId(null)}
          id={editId}
        />
      ) : (
        ""
      )}

      {viewId ? (
        <AdminJobPositionDetail
          open={openView}
          handleClose={() => setOpenView(false)}
          clear={() => setViewId(null)}
          id={viewId}
        />
      ) : (
        ""
      )}
      <Card
        style={{
          padding: "10px",
          background: "#F2F2F2",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            style={{ width: "20%", margin: "10px 0px" }}
            variant="contained"
            onClick={() => setOpenForm(true)}
          >
            Tambah Jabatan
          </Button>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Refresh
              className={styles.actionButtonEdit}
              onClick={() => handleUpdate()}
            />
            <i>
              updated {timeUpdated.hour > 0 ? `${timeUpdated.hour} hour` : ""}{" "}
              {`${timeUpdated.minute} minutes ago`}
            </i>
          </div>
        </div>
        <CustomTable
          column={column}
          data={data}
          listData={listData}
          handleViewData={handleViewData}
          handleEditData={handleEditData}
          deleteClassItem={deleteClassItem}
          deleteTemporary={deleteTemporary}
          activeClassItem={activeClassItem}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          actions={true}
        />
      </Card>
    </>
  );
}
